import React, { FC } from 'react';
import { ImplementationGroup } from '@constants/entities/project';
import { Chip } from '@mui/material';

type Props = {
  tier: ImplementationGroup;
};

const IgBadge: FC<Props> = ({ tier }) => (
  <Chip
    label={tier}
    size="small"
    variant="blue-outlined"
    sx={{ pointerEvents: 'none', flexShrink: 0 }}
  />
);

export default IgBadge;
